import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {APIService} from "@shared/api.service";
import {InvioMailSingle} from "@models/InvioMailSingle.model";

export const invioMailSingleResolver: ResolveFn<InvioMailSingle> = (route, state) => {
  const apiService = inject(APIService);
  let category_id = route.params['category_id'];
  let customer_id = route.params['customer_id'];
  return apiService.get('customerinfodigests/' + category_id + '@' + customer_id);
};
